import React from 'react';
import { Menu, Icon } from 'antd';
import TEXTS from '../../../locale/texts';

const renderMenuAddContacts = ({ lang, hasParams, addContactsHandle }) => {
  const iconStyle = { position: 'relative', top: -3 };
  return (
    <Menu onClick={addContactsHandle} >
      <Menu.Item key="from_file">
        <Icon type="file-add" style={iconStyle} />
        {TEXTS.btnAddContactsFromFile[lang]}
      </Menu.Item>
      <Menu.Item key="from_groups" disabled={hasParams}>
        <Icon type="usergroup-add" style={iconStyle} />
        {TEXTS.btnAddContactsFromGroups[lang]}
      </Menu.Item>
      <Menu.Item key="from_contacts" disabled={hasParams}>
        <Icon type="contacts" style={iconStyle} />
        {TEXTS.btnAddContactsFromContacts[lang]}
      </Menu.Item>
      <Menu.Item key="manual" disabled={hasParams}>
        <Icon type="mobile" style={iconStyle} />
        {TEXTS.btnAddContactsByHand[lang]}
      </Menu.Item>
    </Menu>
  );
};

export { renderMenuAddContacts };
